import {EmailVerificationApiInterface} from "../api/interface/email-verification";
import type {EmailVerificationStatus} from "../api/payload-types/authorize";
import {selectCredentials} from "./authSlice";
import type {RevaThunkAction} from "./revaHooks";

/**
 * #19351: Ask reva-rest to have the verification mail sent to the stored address of the logged-in user.
 * @returns the status reported by account-management, or `"ERROR"` if the request failed
 */
export const requestEmailVerificationThunk =
    (): RevaThunkAction<Promise<EmailVerificationStatus | "ERROR">> =>
    async (_dispatch, getState, {serviceApi}) => {
        const credentials = selectCredentials(getState());
        try {
            const response = await new EmailVerificationApiInterface().execute(serviceApi, credentials!);
            return response.status;
        } catch {
            return "ERROR";
        }
    };
